<template>
  <div class="text-xl text-black text-center" v-html="$t('authentication.header')"></div>
  <div class="w-svw max-w-80 bg-[#f1f1f1] text-black text-center rounded-lg overflow-hidden">
    <img class="block w-full" :src="isHybrid ? steps_hybrid : steps" />
    <div class="text-xl py-1 px-2 font-bold text-center text-[#0789B2]">{{ $t('authentication.description') }}</div>
  </div>
</template>

<script setup>
import steps_hybrid from '../assets/scan-instruction/hybrid_main.gif'
import steps from '../assets/scan-instruction/full-steps.gif'

defineProps({
  isHybrid: Boolean
})

</script>